import Navigation from '@pelckmans/elementis/components/navigation';
import { useTranslation } from 'react-i18next';
import BrandIcon from '../../../shared-components/BrandIcon';

function PelckmansLogo() {
  const { t } = useTranslation();

  return (
    <Navigation aria-label={t('APP_NAV.SIDE_NAV.HOME_NAVIGATION.A11Y_LABEL')}>
      <Navigation.List>
        <Navigation.Item icon={<BrandIcon />} iconOnly to="/">
          {t('APP_NAV.SIDE_NAV.HOME')}
        </Navigation.Item>
      </Navigation.List>
    </Navigation>
  );
}

export default PelckmansLogo;
